import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { WalletService } from "@domain/services/wallet.service";
import { BonusIcon } from "@boundary/components/bonusIcons/bonusIcons";
import styles from "./welcomeGift.module.scss";

const SEEN_KEY = "phodo_welcome_seen";

/**
 * Приветствие с подарком на главном экране.
 *
 * Человек пришёл по флаеру за конкретным подарком — он должен увидеть, что
 * подарок у него, не разыскивая его по меню. Показывается один раз: закрыл —
 * больше не возвращается, а сам подарок остаётся в бонусах.
 */
export function WelcomeGift() {
  const navigate = useNavigate();
  const [label, setLabel] = useState<string | null>(null);
  const [kind, setKind] = useState<string | null>(null);
  const [grantedAt, setGrantedAt] = useState<string | null>(null);

  useEffect(() => {
    let alive = true;
    WalletService.welcome()
      .then((gift) => {
        if (!alive || !gift.granted || !gift.granted_at) return;
        if (localStorage.getItem(SEEN_KEY) === gift.granted_at) return;
        setLabel(gift.label);
        setKind(gift.service_type || gift.kind);
        setGrantedAt(gift.granted_at);
      })
      .catch(() => {
        // Подарок — приятное дополнение, его недоступность ничего не ломает.
      });
    return () => {
      alive = false;
    };
  }, []);

  if (!label) {
    return null;
  }

  const close = () => {
    if (grantedAt) {
      localStorage.setItem(SEEN_KEY, grantedAt);
    }
    setLabel(null);
  };

  return (
    <div className={styles.card}>
      <BonusIcon kind={!kind || kind === "points" ? "points" : kind} className={styles.icon} />
      <div className={styles.body} onClick={() => navigate("/bonuses")}>
        <p className={styles.title}>Спасибо, что зарегистрировались</p>
        <p className={styles.label}>{label}</p>
      </div>
      <button type="button" className={styles.close} onClick={close} aria-label="Закрыть">
        <svg width="14" height="14" viewBox="0 0 14 14" fill="none" aria-hidden>
          <path
            d="M1.5 1.5L12.5 12.5M12.5 1.5L1.5 12.5"
            stroke="currentColor"
            strokeWidth="1.8"
            strokeLinecap="round"
          />
        </svg>
      </button>
    </div>
  );
}
